import { LeftSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { Tag } from 'app/src/shared/components'
import { useTranslation } from 'app/src/shared/hooks'

export function MultiVoucherUsageDetailLeftPanelSide(props: { order: shoppingApi.OrderDetails; className?: string }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct' })

  return (
    <div className={props.className ?? LeftSideDefaultClassName}>
      <div className='flex flex-row'>
        <div className='pl-4'>
          <div>
            <Tag pt={{ root: { className: 'mt-0 mb-0 h-[28px]' } }} tag={t('StateMapping')[props.order.status]?.label} />
          </div>
          <div
            className='mt-4 max-w-lg text-2xl font-bold'
            dangerouslySetInnerHTML={{ __html: props.order.variant.variantName }}
          />
        </div>
      </div>
    </div>
  )
}
